import React from 'react'
import Flex from 'typescript-styled-flex'
import { Trans, withTranslation, WithTranslation } from 'react-i18next'
import Scrollbars from 'react-custom-scrollbars'
import { reduxForm } from 'redux-form'
import {
  ModalFlex,
  ModalHeader,
  ModalHeaderLabel,
} from '../../../components/Template/Modal'
import Button from '../../../components/Template/Button'
import { Loader } from '../../../components/Loader/CalendarLoader'
import { ServicesModalWrapper } from '../../../components/Calendar/ReservationModal'
import { Form, SquareCheckbox } from '../../../components/FormBuilder'
import { IService } from '../../../models/Services'
import { is } from '../../../components/MediaQuery'
import Icon from '../../../components/Template/Modal/CloseButton/Icon'
import useSize from '../../../hooks/useSize'
import servicesSubmit from './ServicesSubmit'

function ServicesModal({
  close,
  open,
  destroy,
  isLoading,
  t,
  services,
  submitChanges,
}: { children?: React.ReactNode } & IServicesModalProps &
  IServicesModalDispatch &
  WithTranslation) {
  const size = useSize()

  function onClose() {
    close()
    destroy()
  }

  function submit() {
    close()
    submitChanges()
  }

  function addString(): string {
    const str = t('z2736_add_button').toLowerCase()
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  const isDesktop = is.desktop

  return (
    <ModalFlex open={open} style={{ overflow: 'hidden' }} onClose={onClose}>
      {!isLoading ? (
        <ServicesModalWrapper>
          <ModalHeader
            style={{ padding: `${16 * size}px`, paddingBottom: '0' }}
          >
            <Flex
              style={{ whiteSpace: 'nowrap', width: '80%' }}
              justifyStart={true}
            >
              <ModalHeaderLabel
                style={{
                  fontSize: `${16 * size}px`,
                  padding: `${5 * size}px 0px`,
                }}
              >
                <Trans i18nKey={'z2736_label_additional_services'}>
                  Dodatkowe usługi
                </Trans>
              </ModalHeaderLabel>
            </Flex>

            <Flex style={{ width: '20%' }} justifyEnd={true} alignCenter={true}>
              <Icon style={{ marginRight: `${-4 * size}px` }} onClick={close} />
            </Flex>
          </ModalHeader>
          <div
            style={{
              marginBottom: `${10 * size}px`,
              marginTop: `${5 * size}px`,
            }}
          >
            <Scrollbars
              hideTracksWhenNotNeeded={true}
              autoHeight
              autoHeightMax={isDesktop ? '70vh' : '200px'}
            >
              <Flex
                column={true}
                style={{
                  padding: `${10 * size}px ${16 * size}px 0px ${16 * size}px`,
                }}
              >
                <Form onSubmit={null}>
                  {services !== undefined &&
                    services.map(service => (
                      <SquareCheckbox.ReduxField
                        size={size}
                        fireEventOnClick={true}
                        wrapLabel={true}
                        name={`s${String(service.id)}`}
                        key={`service-key-${service.id}`}
                        wrapperStyle={{ marginBottom: `${10 * size}px` }}
                        isReverse={true}
                        noSpacing={true}
                        isHorizontal={true}
                        label={service.serviceName}
                      />
                    ))}
                </Form>
              </Flex>
            </Scrollbars>
          </div>
          <Flex
            row={true}
            justifyEnd={true}
            style={{
              marginBottom: `${16 * size}px`,
              marginLeft: `${16 * size}px`,
              marginRight: `${16 * size}px`,
            }}
          >
            <Button
              size={size}
              style={{ width: '100%' }}
              onClick={submit}
              primary={true}
            >
              {addString()}
            </Button>
          </Flex>
        </ServicesModalWrapper>
      ) : (
        <ServicesModalWrapper overflow={true}>
          <Loader />
        </ServicesModalWrapper>
      )}
    </ModalFlex>
  )
}

export default reduxForm({
  destroyOnUnmount: true,
  enableReinitialize: false,
  form: 'services',
  onSubmit: servicesSubmit('create_reservation'),
})(withTranslation()(ServicesModal) as any)

export const ServicesForm = reduxForm({
  destroyOnUnmount: true,
  enableReinitialize: false,
  form: 'services',
  onSubmit: servicesSubmit('update_reservation'),
})(withTranslation()(ServicesModal) as any)

export interface IServicesModalProps {
  open?: boolean
  isLoading?: boolean
  services: IService[]
}

export interface IServicesModalDispatch {
  close?: () => void
  destroy?: any
  submitChanges: () => void
}
